import { FC } from 'react';
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Stack,
  Text,
  Textarea,
} from '@chakra-ui/react';
import { ApiKeyTemplate } from 'types/apiKeyTemplate';

type Props = {
  mode: '登録' | '更新';
  values: ApiKeyTemplate;
  handleClose: () => void;
};

export const ApiKeyTemplateRegistrationResultModalView: FC<Props> = ({
  mode,
  values,
  handleClose,
}) => (
  <ModalContent maxHeight="90vh">
    <ModalHeader p="40px">APIキーテンプレートの{mode}</ModalHeader>
    <ModalCloseButton />
    <ModalBody overflowY="auto" px="40px">
      <Stack spacing="6" direction="column">
        <FormControl>
          <FormLabel>テンプレート名</FormLabel>
          <Input
            type="text"
            value={values.name}
            variant="flushed"
            isReadOnly
            isTruncated
          />
        </FormControl>
        <FormControl>
          <FormLabel>テンプレート</FormLabel>
          <Textarea
            value={values.template}
            rows={8}
            variant="flushed"
            isReadOnly
          />
        </FormControl>
      </Stack>
      <Text align="center" fontWeight="bold" mt="60px">
        {mode}が完了しました
      </Text>
    </ModalBody>
    <ModalFooter justifyContent="center" mx="20px" gap="16px" p="40px">
      <Button
        w="140px"
        colorScheme="blackAlpha"
        variant="outline"
        onClick={handleClose}
      >
        閉じる
      </Button>
    </ModalFooter>
  </ModalContent>
);
